import axios from '../../utils/axios';
import { INTERNAL_SERVER_ERROR } from '../../constants/http';

const getCategoryCountTree = async (date) => {
  try {
    const { data } = await axios.get(`/api/category-counts/tree${date ? `?date=${date}` : ''}`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const getCategoryCountHistory = async (
  groupBy, nodeId, supermarketId, startDate, endDate,
) => {
  try {
    const { data } = await axios.get(`/api/category-counts/history?groupBy=${groupBy}&nodeId=${nodeId || ''}&supermarketId=${supermarketId || ''}&startDate=${startDate}&endDate=${endDate}`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

export {
  getCategoryCountTree,
  getCategoryCountHistory,
};
